export type Conversation = {
	content: string
	role: string
}

export enum DisruptionType {
	Future = 'future',
	Marketplace = 'marketplace',
}

export enum ResponseIndex {
	CompanyExamples = 0,
	CompetitorResponse = 1,
	CounterResponse = 2,
}

export interface DisruptionScenario {
	authorIdeation: string[]
	prompt: string
	responseConversation: Conversation[][]
	responses: string[][]
}

/**
 * Fields owned by useGameSession.
 * When the API begins returning persisted scenario data, add
 * `initialScenarios?: Partial<Record<DisruptionType, DisruptionScenario>>`
 * here so useScenario can seed its state from it.
 */
export interface GameSession {
	companyName: string
	companyProblem: string
	endTime: string | null
	gameId: string | null
	gameTitle: string
	isReady: boolean
	resetAll: () => void
	setCompanyName: (value: string) => void
	setCompanyProblem: (value: string) => void
	setTopic: (value: string) => void
	topic: string
}

// Seed each disruption type with a minimal format-priming conversation.
// The backend AI infers its response format from conversation history;
// without this, a first call returns a JSON-wrapped string instead of plain text.
export const initialPromptConversation: Record<DisruptionType, Conversation[]> =
	{
		[DisruptionType.Future]: [
			{ content: '', role: 'user' },
			{ content: '{"futureTrend":""}', role: 'assistant' },
		],
		[DisruptionType.Marketplace]: [
			{ content: '', role: 'user' },
			{ content: '{"companyDisruption":""}', role: 'assistant' },
		],
	}

export const createEmptyScenario = (): DisruptionScenario => ({
	authorIdeation: ['', ''],
	prompt: '',
	responseConversation: [[], [], []],
	responses: [[], [], []],
})
